'use client';

import { microsoftClarityProjectId } from '@common';
import Clarity from '@microsoft/clarity';
import { isClarityEnabled } from '@utils';
import { useEffect } from 'react';

export const useClarity = (projectId: string, email: string) => {
  useEffect(() => {
    if (!microsoftClarityProjectId) {
      console.warn('Clarity project ID is not provided.');
      return;
    }
    if (!email) {
      console.warn('Clarity email is not provided.');
      return;
    }

    try {
      if (isClarityEnabled()) {
        Clarity?.init(microsoftClarityProjectId);
        Clarity?.identify(email);
      } else {
        console.log('Clarity is not enabled.');
      }
    } catch (err) {
      console.error('Clarity initialization failed:', err);
    }
  }, [projectId, email]);
};
